<template>
  <v-container>
    <Vanta />
    <v-row justify="center" align="center" class="mt-5" text="center">
      <p class="text-h3 welcome my-15">Welcome!!</p>
    </v-row>
  </v-container>
</template>

<script>
import Vanta from "../components/Home/Vanta";

export default {
  components: {
    Vanta
  },
};
</script>
<style>
.welcome {
  color: #ACB6E5;
  background: -webkit-linear-gradient(0deg, #2247ee, #12e6bf);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>